<template>
  <div class="user">
    <div class="avatarWrapper">
      <van-image fit="cover" round :src="require('@/assets/img/avatar.png')" />
    </div>
    <div class="userWrapper">
      <span class="username" v-if="$store.state.name">
        <div>{{ $store.state.name }}</div>
         <div class="little">{{ $store.state.account }}</div>
          <div class="little">{{ $store.state.roles }}</div>
      </span>
      <span v-else class="username" @click="goLogin">登录</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "user",
  data() {
    return {
      user: {},
    };
  },
  methods: {
    goLogin() {
      this.$router.push("/login");
    },
  },
};
</script>

<style lang="less" scoped>
.user {
  background: linear-gradient(to right, #fd9126, #ff5000);
  height: 135px;
  display: flex;
  align-items: center;

  .avatarWrapper {
    width: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    /deep/ .van-image--round {
      width: 65px;
      height: 65px;
    }
  }

  .userWrapper {
    .username {
      color: #fff;
      font-size: 18px;
    }
    .little{
       font-size: 14px;
    }

    align-items: center;
    display: flex;
    flex: 1;
  }

  .actionWrapper {
    display: flex;
    height: 100%;
    align-items: flex-start;
    justify-content: flex-end;

    * {
      color: #fff;
    }

    .setting {
      padding: 10px;

      .icon {
        vertical-align: middle;
        padding: 0 5px 0 0;
      }

      .title {
        font-size: 12px;
      }
    }
  }
}
</style>